<template lang="pug" src="./custom-fun-photo-albums.pug"></template>

<script>
import ImgRow from 'components/custom/custom-fun-img-row/custom-fun-img-row'
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props'],
  components: {
    ImgRow,
    Title
  }
}
</script>



// WEBPACK FOOTER //
// custom-fun-photo-albums.vue?5fe37480